/**
 * Тонкая обёртка над window.Telegram.WebApp.
 * Держим её в одном файле: если Telegram поменяет API, чинить нужно здесь.
 */

interface WebApp {
  initData: string;
  initDataUnsafe: { user?: { id: number; first_name?: string; username?: string; photo_url?: string } };
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string>;
  ready(): void;
  expand(): void;
  close(): void;
  openLink(url: string, options?: { try_instant_view?: boolean }): void;
  openTelegramLink(url: string): void;
  /** Оплата звёздами: счёт открывается внутри Telegram, без ухода в браузер. */
  openInvoice?(url: string, cb?: (status: 'paid' | 'cancelled' | 'failed' | 'pending') => void): void;
  requestContact?(cb: (ok: boolean, res?: { responseUnsafe?: { contact?: { phone_number: string } } }) => void): void;
  showAlert(message: string, cb?: () => void): void;
  setHeaderColor?(color: string): void;
  setBackgroundColor?(color: string): void;
  disableVerticalSwipes?(): void;
  BackButton: { show(): void; hide(): void; onClick(cb: () => void): void; offClick(cb: () => void): void };
  HapticFeedback: {
    impactOccurred(style: 'light' | 'medium' | 'heavy'): void;
    notificationOccurred(type: 'error' | 'success' | 'warning'): void;
    selectionChanged(): void;
  };
}

const stub: WebApp = {
  initData: '',
  initDataUnsafe: {},
  colorScheme: 'dark',
  themeParams: {},
  ready() {}, expand() {}, close() {},
  openLink(url) { window.open(url, '_blank'); },
  openTelegramLink(url) { window.open(url, '_blank'); },
  showAlert(m) { window.alert(m); },
  BackButton: { show() {}, hide() {}, onClick() {}, offClick() {} },
  HapticFeedback: { impactOccurred() {}, notificationOccurred() {}, selectionChanged() {} },
};

export const tg: WebApp =
  (window as unknown as { Telegram?: { WebApp?: WebApp } }).Telegram?.WebApp ?? stub;

export const isInTelegram = tg.initData.length > 0;

tg.setHeaderColor?.('#0A0C18');
tg.setBackgroundColor?.('#0A0C18');
tg.disableVerticalSwipes?.();

export const haptic = {
  tap: () => tg.HapticFeedback.impactOccurred('light'),
  hit: () => tg.HapticFeedback.impactOccurred('heavy'),
  ok: () => tg.HapticFeedback.notificationOccurred('success'),
  no: () => tg.HapticFeedback.notificationOccurred('error'),
};

/** Отпечаток устройства для антифрода (раздел 12, уровень 1). */
export function fingerprint(): string {
  const parts = [
    navigator.userAgent, navigator.language,
    String(screen.width), String(screen.height), String(screen.colorDepth),
    String(new Date().getTimezoneOffset()),
  ].join('|');
  let hash = 0;
  for (let i = 0; i < parts.length; i++) hash = (hash * 31 + parts.charCodeAt(i)) | 0;
  return (hash >>> 0).toString(36);
}
